<template>
  <v-container
    id="regular-tables"
    fluid
    tag="section"
  >



      <v-row>
        <v-col sm="12">
 <base-material-card
          icon="mdi-credit-card"
          color="primary"
          title="Subscriptions"
          :loading="loading"
        >
    <v-data-table Subscriptions :headers="headers" 
    :items="subscriptions" :items-per-page="5">
      <template v-slot:item.plan.amount="{ item }">
        R&nbsp;{{ (item.plan.amount / 100).toFixed(2) }}
    </template>
    <template v-slot:item.current_period_start="{ item }">
        {{ (item.current_period_start * 1000) | moment('DD/MM/YYYY') }}
    </template>
    <template v-slot:item.current_period_end="{ item }">
        {{ (item.current_period_end * 1000) | moment('DD/MM/YYYY') }}
    </template>
    <template v-slot:item.status="{ item }">
        <span :class="getColor(item.status)">{{ item.status.replace('_', ' ') }}</span>
    </template>
    <template v-slot:item.action="{ item }">        
        <v-btn color="error" text @click="confirm(item)" v-if="item.status == 'active' || item.status == 'past_due' || item.status == 'unpaid'">cancel</v-btn>
    </template>

    <template v-slot:item.cancel_at_period_end="{ item }">
        {{ item.cancel_at_period_end || item.status != 'active' ? 'No' : 'Yes' }}
    </template>

    </v-data-table>
    
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" :to="{ name: 'New Subscription' }">
            Subscribe
          </v-btn>
        </v-card-actions>
 </base-material-card>
        </v-col>

    <v-dialog
      v-model="dialog"
      width="500"
    >
      <v-card>
        <v-card-title
          class="headline primary white--text"
          dark
          primary-title
        >
          Are you sure?
        </v-card-title>

        <v-card-text class="py-20">
          <p>
          Are you sure you would like to cancel this subscription?
          </p>
        </v-card-text>

        <v-divider></v-divider>

       <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog = false">No</v-btn>
          <v-btn color="error" text @click="cancel">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

        <v-col sm=12>
          <base-material-card
                    icon="mdi-file-document"
                    color="primary"
                    title="Invoices"
                    :loading="loading"
                  >
              <v-data-table :headers="invoiceHeaders" 
              :items="invoices" :items-per-page="10">
                <template v-slot:item.total="{ item }">
                  R&nbsp;{{ (item.total / 100).toFixed(2) }}
                </template>
                <template v-slot:item.subtotal="{ item }">
                    R&nbsp;{{ (item.subtotal / 100).toFixed(2) }}
                </template>
                <template v-slot:item.discount.coupon.amount_off="{ item }">
                    R&nbsp;{{ (item.discount) ? item.discount.coupon.amount_off / 100 : '0.00' }}
                </template>
                <template v-slot:item.created="{ item }">
                    {{ (item.created * 1000) | moment('DD/MM/YYYY') }}
                </template>
                <template v-slot:item.paid="{ item }">
                    <span :class="getPaidColor(item.paid)">{{ item.paid ? 'Yes' : 'No' }}</span>
                </template>

                <template v-slot:item.invoice_pdf="{ item }">
                  <v-btn text :href="item.invoice_pdf" class="grey--text"><v-icon>mdi-download</v-icon></v-btn>
                </template>
              </v-data-table>
          </base-material-card>
        </v-col>
      </v-row>







    <!-- <v-row>
    <v-col cols="12" md="6">
      <weight-chart-card />
    </v-col>
    <v-col cols="12" md="6">
    <base-material-card
      icon="mdi-speedometer"
      color="primary"
      title="Weigh-ins"
      class="px-5 py-1"
      :loading="deletingWeight"
    >
        <v-data-table
          :headers="headers"
          :items="weighins"
          :items-per-page="5"
          mobile-breakpoint="400"
        >
          <template v-slot:item.l="{ item }">           
              <span>{{ isNaN(item.p - item.w) ? 0 : (Math.abs(item.p - item.w)).toFixed(2).replace(/[.,](00)|0$/, '') }} {{ profile.u }}</span>
              <v-icon v-if="item.p - item.w > 0" color="secondary">mdi-arrow-bottom-right</v-icon>
              <v-icon v-if="item.p - item.w < 0" color="primary">mdi-arrow-top-right</v-icon>
              <v-icon v-if="item.p - item.w == 0 || isNaN(item.p - item.w)" color="grey">mdi-arrow-right</v-icon>              
          </template>
          <template v-slot:item.w="{ item }">
            {{ (item.w).toFixed(1) }} {{ profile.u }}
          </template>
          <template v-slot:item.d="{ item }">
            {{ item.d | moment('DD MMM YY') }}
          </template>

          <template v-slot:item.actions="{ item }">
            <v-icon small @click="confirmDelete(item)">mdi-delete</v-icon>
          </template>

        </v-data-table>
        <v-card-actions>
          <v-spacer />
          <v-btn type="submit" color="primary" @click="setWeighInModal(true)">Weigh In</v-btn>
          <v-spacer />
        </v-card-actions>
    </base-material-card>
    </v-col>
    </v-row>
    <v-dialog v-model="showConfirmDelete" max-width="300">
      <v-card>
        <v-card-title>
          <span>Are you sure?</span>
          <v-spacer />
          <v-icon aria-label="Close" @click="showConfirmDelete=false">mdi-close
          </v-icon>
        </v-card-title>
        <v-card-text class="pb-6 pt-12 text-center">
          Would you like to delete your weigh-in for {{ selectedWeight.d | moment('DD MMMM YYYY') }}?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mr-3" text  @click="showConfirmDelete=false">
            No
          </v-btn>
          <v-btn  color="error" text @click="deleteWeightConfirmed()">
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <base-material-snackbar
      v-model="showSnackbar"
      :type="snackbartype"
      top
      center
    >
      <span v-text="snackbarmessage">
      </span>
    </base-material-snackbar> -->
  </v-container>
</template>

<script>
  import { mapState, mapActions, mapMutations } from 'vuex'

  export default {
    components: {
    },
    name: 'invoicing',
    data () {
      return {
        // selectedWeight: {d:'',w:''},
        // showConfirmDelete: false,
        // showSnackbar: false,
        // snackbarmessage: '',
        // snackbartype: 'success',
        dialog: false,
        headers: [
          {
            text: 'Subscription',
            align: 'left',
            value: 'plan.nickname',
          },
          {
            text: 'Status',
            align: 'center',
            value: 'status',
          },
          {
            text: 'Price',
            align: 'end',
            value: 'plan.amount',
          },
          {
            text: 'Last renewed',
            align: 'end',
            value: 'current_period_start',
          },
          {
            text: 'Renewing on',
            align: 'end',
            value: 'current_period_end',
          },
          {
            text: 'Auto Renew',
            align: 'center',
            value: 'cancel_at_period_end'
          },
          {
            text: 'Actions',
            align: 'center',
            value: 'action',
          },
        ],      
        invoiceHeaders: [
          {
            text: 'Created',
            align: 'end',
            value: 'created',
          },
          {
            text: 'Subtotal',
            align: 'end',
            value: 'subtotal',
          },
          {
            text: 'Discount',
            align: 'end',
            value: 'discount.coupon.amount_off',
          },
          {
            text: 'Total',
            align: 'end',
            value: 'total',
          },
          {
            text: 'Paid',
            align: 'center',
            value: 'paid',
          },
          {
            text: 'Download',
            sortable: false,
            value: 'invoice_pdf',
            align: 'center'
          }
        ],
      }
    },
    computed: {
      ...mapState('Subscriptions', ['plan', 'loading', 'subscriptions','invoices','notSubscribed']),
      // ...mapState('Profile', ['profile']),
      // weighins() {
      //   const weights = Array.from(this.weightDiary);
      //   let prev = weights.slice;
      //   weights.forEach(item => {
      //     item.p = prev;
      //     prev = item.w
      //   })
      //   return weights.reverse();
      // }
    },

    methods: {
      ...mapActions('Subscriptions', ['loadSubscriptions', 'loadInvoices', 'cancelSubscription']),
      ...mapMutations('Ui', ['showSnackbar' ]),
      
      cancel() {
        this.dialog = false;
        this.cancelSubscription(this.selectedSubscription)
        .then(() => {
          this.loadSubscriptions(this.profile.s);
        });
      },
      getColor(status) {
        let col = 'grey--text'
        switch (status) {
          case 'active': col =  'green--text'; break;
          case 'past_due': col =  'red--text'; break;
          case 'unpaid': col =  'red--text'; break;
          case 'incomplete': col =  'amber--text'; break;
        }
        return col
      },
      getPaidColor(paid) {
        if (paid) {
          return 'success--text';
        } else {
          return 'error--text';
        }
      }
      // ...mapMutations('Ui', ['setWeighInModal']),
      // confirmDelete(weight){
      //   this.selectedWeight = weight;
      //   this.showConfirmDelete = true;
      // },
      // showSnackBar(barType, barMessage) {
      //   this.snackbarmessage = barMessage;
      //   this.snackbartype = barType;
      //   this.showSnackbar = true;
      //   setTimeout(() => {
      //     this.showSnackbar = false;
      //   }, 2000);
      // },
      // deleteWeightConfirmed() {
      //   this.showConfirmDelete = false;
      //   this.deleteWeight(this.selectedWeight)
      //   .then(() => {
      //     this.showSnackBar('success', 'Weigh-in deleted successfully')
      //   })
      //   .catch(() => {
      //     this.showSnackBar('error', 'There was an error deleting your weigh-in')
      //   });
      // }
    },
    mounted: function() {
      this.loadSubscriptions()
      .catch(() => {        
        this.showSnackbar({
          snackbarType: 'error',
          snackbarMessage: 'There was an error loading your subscriptions',
        });
      })
      this.loadInvoices()
      .catch(() => {        
        this.showSnackbar({
          snackbarType: 'error',
          snackbarMessage: 'There was an error loading your invoices',
        });
      })
    }
  }
</script>
<style >
</style>